import { IFieldSchema } from "./IFieldSchema";
import CControl from "./CControl";
import { CForm } from "./JSForm";

export interface ICCheckBoxProps {
    form: CForm;
    schema: IFieldSchema;
}

class CCheckBox extends CControl {

    #props: ICCheckBoxProps;

    constructor(props: ICCheckBoxProps) {
        super({ form: props.form, schema: props.schema });
        this.#props = props;
    }

    get label(): string {
        return this.#props.schema.label;
    }

}

export default CCheckBox;